import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Typography } from "@material-ui/core";
import {
  tableCellRender,
  stringFilterOperators,
  dateFilterOperators,
  getLatestUpdateAgro,
  getRandomInt,
} from "../util/tableUtils";
import { DataGridCystellarTable } from "../util/DataGridCystellarTable";
import { formatDateValue } from "../util/tableUtils";

export const AgriculturePolicyClaimsList = (props) => {
  const { t } = useTranslation();
  const [lastUpdateDateMsg, setLastUpdateDateMsg] = useState("");
  const [pinnedSumRow, setPinnedSumRow] = useState({ _id: getRandomInt() });

  useEffect(() => {
    getLatestUpdateAgro("/serviceLogs/agriculture?service=agricultureDb_sinistri").then((lastUpdateMsg) => {
      setLastUpdateDateMsg(lastUpdateMsg);
    });
  }, []);

  useEffect(() => {
    if (props?.claims?.length) {
      const compensationSum = props.claims.reduce(
        (accumulator, currentClaim) => accumulator + currentClaim.compensationTotal,
        0,
      );

      const sumParcelRow = {
        _id: getRandomInt(),
        compensationTotal: tableCellRender(compensationSum),
        cadastralRecord: t("table.sum"),
      };
      setPinnedSumRow(sumParcelRow);
    }
  }, [props.claims, t]);

  const claimColumns = [
    {
      field: "cadastralRecord",
      headerName: t("agriculture.claims.cadastralRecord"),
      valueGetter: (params) => {
        const currentCadastralRecord = params.row.cadastralRecord;

        // because of the pinned row label on the left side, the cadastralRecord can be a string as well
        return currentCadastralRecord && typeof currentCadastralRecord === "number"
          ? parseInt(currentCadastralRecord)
          : currentCadastralRecord;
      },
    },

    {
      field: "bulletinID",
      headerName: t("agriculture.bulletinId"),
    },

    {
      field: "adversityDescription",
      headerName: t("agriculture.claims.adversityDescription"),
    },
    {
      field: "perilName",
      headerName: t("agriculture.perilName"),
    },
    {
      field: "adversityBase",
      headerName: t("agriculture.claims.adversityBase"),
    },
    {
      field: "adversitySurcharge",
      headerName: t("agriculture.claims.adversitySurcharge"),
    },
    {
      field: "adversityOverall",
      headerName: t("agriculture.claims.adversityOverall"),
    },

    {
      field: "fixedExcessApplied",
      headerName: t("agriculture.claims.fixedExcess"),
    },
    {
      field: "compensationLimit",
      headerName: t("agriculture.claims.compensationLimit"),
    },
    {
      field: "excess",
      headerName: t("agriculture.claims.excess"),
    },
    {
      field: "liquidable",
      headerName: t("agriculture.claims.liquidable"),
    },
    {
      field: "compensationTotal",
      headerName: t("agriculture.claims.totalCompensation"),
    },
    {
      field: "periziaDate",
      headerName: t("agriculture.assessmentDate"),
      sortable: false,
      type: "date",
      filterOperators: dateFilterOperators,
      valueGetter: (params) => (params.row.periziaDate ? formatDateValue(params.row.periziaDate) : ""),
    },
  ];

  const columns = claimColumns.map((tableColumn) => ({
    valueFormatter: (params) => tableCellRender(params.value),
    filterOperators: stringFilterOperators,
    flex: 1,
    ...tableColumn,
  }));

  return (
    <Box>
      <Paper>
        <Box p={2} pt={2}>
          <Typography
            variant={"h2"}
            component={"span"}
            style={{
              fontSize: "1.3rem",
              fontWeight: 400,
            }}
          >
            {t("agriculture.claims.claimList")}
          </Typography>
        </Box>
        <div style={{ maxHeight: "40vw", maxWidth: "100%", overflow: "auto" }}>
          <DataGridCystellarTable
            columns={columns}
            rows={props?.claims}
            rowCount={props?.claims?.length}
            getRowId={(rowData) => rowData._id}
            pagination={false}
            loading={props.isLoading}
            customToolbarComp={lastUpdateDateMsg ? true : false}
            customToolbarCompMsg={lastUpdateDateMsg}
            customNoRowsMsg={t("policy.emptyClaimsList")}
            pinnedRows={props?.claims?.length ? { bottom: [pinnedSumRow] } : {}}
          />
        </div>
      </Paper>
    </Box>
  );
};
